/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A surface's resolved share card. Server-rendered into the HTML so social unfurlers and non-JavaScript crawlers can read it.
 * @export
 * @interface SurfaceMeta
 */
export interface SurfaceMeta {
    /**
     * 
     * @type {string}
     * @memberof SurfaceMeta
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceMeta
     */
    description: string;
    /**
     * Absolute URL of the share image.
     * @type {string}
     * @memberof SurfaceMeta
     */
    image: string;
    /**
     * Absolute canonical URL for this surface.
     * @type {string}
     * @memberof SurfaceMeta
     */
    canonical: string;
}

/**
 * Check if a given object implements the SurfaceMeta interface.
 */
export function instanceOfSurfaceMeta(value: object): value is SurfaceMeta {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('image' in value) || value['image'] === undefined) return false;
    if (!('canonical' in value) || value['canonical'] === undefined) return false;
    return true;
}

export function SurfaceMetaFromJSON(json: any): SurfaceMeta {
    return SurfaceMetaFromJSONTyped(json, false);
}

export function SurfaceMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'image': json['image'],
        'canonical': json['canonical'],
    };
}

export function SurfaceMetaToJSON(json: any): SurfaceMeta {
    return SurfaceMetaToJSONTyped(json, false);
}

export function SurfaceMetaToJSONTyped(value?: SurfaceMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'image': value['image'],
        'canonical': value['canonical'],
    };
}

